import React from 'react';
import Modal from '../../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDashboardContext } from '../../context';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import CustomToast from '../../../../components/Toast';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../../features/authentication/authSlice';
import { useUpdateEmailIdMutation } from '../../../../features/authentication/authApiSlice';

const UpdateEmail = () => {
  const user = useSelector(selectCurrentUserData);
  const [updateEmailId] = useUpdateEmailIdMutation();
  const [password, setPassword] = React.useState('');
  const { updateEmailModal, setUpdateEmailModal, email, setEmail } = useDashboardContext();
  const [updatingEmail, setUpdatingEmail] = React.useState('');

  React.useEffect(() => {
    if (updateEmailModal) {
      setUpdatingEmail(email);
    }
  }, [updateEmailModal]);

  const closeUpdateEmailModal = () => {
    setUpdateEmailModal(false);
    setPassword('');
  };

  const updateEmailIdHandler = async () => {
    if (password === '') {
      CustomToast('Please enter password', 'error');
      return;
    }
    if (updatingEmail === '') {
      CustomToast('Please enter email', 'error');
      setUpdatingEmail('');
      return;
    }
    try {
      const updateEmailResponse = await updateEmailId({
        email: updatingEmail,
        password
      }).unwrap();
      CustomToast('Email updated successfully', 'success');
      setEmail(updatingEmail);
      closeUpdateEmailModal();
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log(ex);
      }
    }
  };
  return (
    <Modal
      contentWidth="1000px"
      isOpen={updateEmailModal}
      titleName={'Set Your Email Address'}
      onClose={closeUpdateEmailModal}>
      <div className="update-email">
        <div className="update-email-box mb-4">
          <div className="row">
            <div className="col-lg-6 mb-3">
              <label className="form-label">Email Address</label>
              <input
                onChange={(e) => setUpdatingEmail(e.target.value)}
                value={updatingEmail}
                type="text"
                placeholder=""
                className="form-control"
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label className="form-label">Castle Learning Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=""
                className="form-control"
              />
            </div>
            <div className="col-12 info-text  d-flex justify-content-between align-items-center flex-wrap gap-3">
              <p className="mb-0">
                {' '}
                <span>
                  <FontAwesomeIcon icon={faInfo} />
                </span>
                Note: When setting this email, students and teachers will be able to use this as an
                alternate login id
              </p>
              <div>
                <button onClick={closeUpdateEmailModal} className="btn btn-castleGray me-2">
                  Cancel
                </button>
                <button onClick={updateEmailIdHandler} className="btn btn-castleRed">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
        <p>
          <strong>Privacy statement:</strong> Email addresses are considered to be extremely private
          and will not be shared with anyone. We request your Email address in order to be able to
          email your Castle Learning ID and Password to you at home in case you cannot remember
          them.
        </p>
        <p className="mb-0">
          If you forget your ID and Password when you are at home, you can click the Forgot your
          Password link on the sign-in page, enter the email address you specify here, and your ID
          and Password will be emailed to you.
        </p>
      </div>
    </Modal>
  );
};

export default UpdateEmail;
